// apps/frontend/src/components/onboarding/AutoTutorialMount.tsx
//
// Auto-trigger du tutorial Glowp au 1er login.
// Logique :
//  - User doit etre authentifie
//  - shouldShowTutorial() = pas dismiss et pas snooze
//  - sessionStorage flag empeche le re-trigger dans la meme session
//    (l'user navigue entre pages -> tutorial ne re-ouvre pas)
//  - Delai 1500ms apres mount pour laisser la page se rendre avant de
//    surgir une modal (memory feedback_silence_precision)

import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { shouldShowTutorial } from '../../lib/tutorialState';
import { GlowpTutorialModal } from './GlowpTutorialModal';

const SESSION_FLAG = 'glowp_tutorial_session_shown';

const AutoTutorialMount = () => {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    if (typeof window === 'undefined') return;

    try {
      const sessionShown = sessionStorage.getItem(SESSION_FLAG) === '1';
      if (sessionShown) return;
      if (!shouldShowTutorial()) return;

      const timer = window.setTimeout(() => {
        sessionStorage.setItem(SESSION_FLAG, '1');
        setOpen(true);
      }, 1500);

      return () => window.clearTimeout(timer);
    } catch {
      // sessionStorage indisponible (Safari prive) : ne pas crash, juste
      // skip l'auto-trigger.
    }
  }, [isAuthenticated]);

  return <GlowpTutorialModal isOpen={open} onClose={() => setOpen(false)} />;
};

export default AutoTutorialMount;
